import React from 'react'

import AdminPageTitle from '../../../components/AdminPageTitle/AdminPageTitle'
import { BackwardOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { PageForm, PageFormFields } from '../../../components/PageForm/PageForm'
import pagesService from '../../../services/pagesService'
import { message } from 'antd'
import { Helmet } from 'react-helmet-async'

export const AdminPageCreatePage: React.FC = () => {
  const navigate = useNavigate()

  const onSavePage = ({ title, url, content }: PageFormFields) => {
    pagesService.create(title, url, content).then((data) => {
      message.success(`Страница "${data.title}" успешно создана`)
      navigate('/pages')
    }).catch((error) => {
      message.error(error.message)
    })
  }

  return (
    <div>
      <Helmet><title>Prisma — Создать страницу</title></Helmet>
      <AdminPageTitle
        title={'Создать страницу'}
        buttonText={'Назад'}
        icon={<BackwardOutlined/>}
        onClickButton={() => navigate('/pages')}
      />
      <PageForm onSubmit={onSavePage}/>
    </div>
  )
}
